module.exports = __webpack_public_path__ + "img/firefighter.be5030ca.webp";